/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_S4Inputs */

const en_tut_inbox_s4 = /** @type {(inputs: Tut_Inbox_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide what is allowed to interrupt you in **Settings → Notifikasi**: per event type, not one big on/off switch.`)
};

const id_tut_inbox_s4 = /** @type {(inputs: Tut_Inbox_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur apa yang boleh mengganggu Anda di **Settings → Notifikasi**: per jenis kejadian, bukan tombol besar mati-hidup.`)
};

/**
* | output |
* | --- |
* | "Decide what is allowed to interrupt you in **Settings → Notifikasi**: per event type, not one big on/off switch." |
*
* @param {Tut_Inbox_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_s4 = /** @type {((inputs?: Tut_Inbox_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_s4(inputs)
	return en_tut_inbox_s4(inputs)
});